var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anchor-wrapper"},[_c('ul',{ref:"tabs",staticClass:"anchor-tab",class:_vm.tabType,style:(_vm.calcStyle)},_vm._l((_vm.tabs.data),function(item,index){return _c('li',{key:index,class:{ active: index === _vm.curTabIndex },on:{"click":function($event){return _vm.changeTab(index, $event)}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title",style:({
            color:
              _vm.curTabIndex === index
                ? _vm.tabs.style.selectedTitleColor
                : _vm.tabs.style.unselectTitleColor
          })},[_vm._v(" "+_vm._s(item.title)+" ")]),_c('div',{staticClass:"sub-title",style:({
            color:
              _vm.curTabIndex === index
                ? _vm.tabs.style.selectedSubTitleColor
                : _vm.tabs.style.unselectSubTitleColor,
            backgroundColor:
              _vm.curTabIndex === index ? _vm.tabs.style.subTitleBgColor : ''
          })},[_vm._v(" "+_vm._s(item.subTitle)+" ")])]),(_vm.tabs.data && index != _vm.tabs.data.length - 1)?_c('div',{staticClass:"right-border"}):_vm._e()])}),0),_c('img',{staticClass:"shadow",attrs:{"src":require("@/images/category_feed/shadow.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }